// Copyright 2024 Sorama B.V.
import { Color } from "./Color";
import { NamedColor } from "./NamedColor";

// Copyright 2024 Sorama B.V.
export class CategoricalColorPalettes {
    // https://www.tableau.com/blog/colors-upgrade-tableau-10-56782
    // They did a lot of color research on this one (functionality and aesthetics)
    // They are well spaced out in the CIELAB color space, meaning they are easy to distinguish
    // They also have spaced out luminosity, meaning they are colorblind/greyscale friendly
    // They correspond to simple color names like red, blue, purple, brown, etc.
    public static Tableau10(): NamedColor[] {
        return [
            new NamedColor("blue", Color.fromHex("4E79A7")),
            new NamedColor("orange", Color.fromHex("F28E2B")),
            new NamedColor("red", Color.fromHex("E15759")),
            new NamedColor("teal", Color.fromHex("76B7B2")),
            new NamedColor("green", Color.fromHex("59A14E")),
            new NamedColor("yellow", Color.fromHex("EDC949")),
            new NamedColor("purple", Color.fromHex("B07AA2")),
            new NamedColor("pink", Color.fromHex("FF9DA7")),
            new NamedColor("brown", Color.fromHex("9C755F")),
            new NamedColor("grey", Color.fromHex("BAB0AC")),
        ];
    }

    // Just added 10 more colours that seemed to work well with the original 10
    // Reason: we often don't need more than 10 colors, and the 10 first colours
    // of the tableau10 are much nicer than the ones from the pairs
    public static Tableau10Extended(): NamedColor[] {
        return this.Tableau10().concat([
            new NamedColor("corn", Color.fromHex("f0e9bd")),
            new NamedColor("sky", Color.fromHex("A0CBE8")),
            new NamedColor("peach", Color.fromHex("FFBE7D")),
            new NamedColor("lime", Color.fromHex("8CD17D")),
            new NamedColor("pink", Color.fromHex("FABFD2")),
            new NamedColor("ochre", Color.fromHex("B6992D")),
            new NamedColor("tea", Color.fromHex("D3EFD3")),
            new NamedColor("lavender", Color.fromHex("D4A6C8")),
            new NamedColor("avocado", Color.fromHex("8aaf4c")),
            new NamedColor("lightgrey", Color.fromHex("DDDDDD")),
        ]);
    }

    // See Tableau10,
    // This is tableau10, but with the blue color removed since it is too similar to the portal background, making it hard to distinguish
    public static TableauPortal(): NamedColor[] {
        return this.Tableau10().filter((c) => c.name !== "blue");
    }

    // See Tableau10Extended,
    // This is tableau10Extended, but with the blue color removed since it is too similar to the portal background, making it hard to distinguish
    public static TableauExtendedPortal(): NamedColor[] {
        return this.Tableau10Extended().filter((c) => c.name !== "blue");
    }

    // https://jrnold.github.io/ggthemes/reference/tableau_color_pal.html
    // Supposedly also from Tableau's new palette
    public static Tableau20Pairs(): NamedColor[] {
        return [
            new NamedColor("blue", Color.fromHex("4E79A7")),
            new NamedColor("sky", Color.fromHex("A0CBE8")),
            new NamedColor("orange", Color.fromHex("F28E2B")),
            new NamedColor("peach", Color.fromHex("FFBE7D")),
            new NamedColor("green", Color.fromHex("59A14E")),
            new NamedColor("lime", Color.fromHex("8CD17D")),
            new NamedColor("red", Color.fromHex("E15759")),
            new NamedColor("pink", Color.fromHex("FF9D9A")),
            new NamedColor("purple", Color.fromHex("B07AA1")),
            new NamedColor("lavender", Color.fromHex("D4A6C8")),
            new NamedColor("brown", Color.fromHex("9C755F")),
            new NamedColor("beige", Color.fromHex("D7B5A6")),
            new NamedColor("mauve", Color.fromHex("D37295")),
            new NamedColor("lilac", Color.fromHex("FABFD2")),
            new NamedColor("grey", Color.fromHex("79706E")),
            new NamedColor("slate", Color.fromHex("BAB0AC")),
            new NamedColor("ochre", Color.fromHex("B6992D")),
            new NamedColor("gold", Color.fromHex("F1CE63")),
            new NamedColor("teal", Color.fromHex("499894")),
            new NamedColor("aqua", Color.fromHex("86BCB6")),
        ];
    }
}
